import { useUser } from "@/queries/user/useUser";
import { Navigate, useLocation } from "react-router";
import { UserStatus } from "@/api/SolarCloudApi";

export default function BuyPanelsActiveRedirect({ children }: { children: React.ReactNode }) {
  const { data: user } = useUser();
  const location = useLocation();

  const isRootPath =
    location.pathname === "/buypanels" || location.pathname === "/buypanels/";

  if (user?.status === UserStatus.ACTIVE && isRootPath) {
    return <Navigate to="/buysolar" replace />;
  }

  return <>{children}</>;
}
